











const helpers = {







  originCDN(env) {
    const prods = ['prod1_h_w', 'prod2_h_2'];
    const environments = [
      'dev1_h_w',
      'dev2_h_w',
      'dev3_h_w',
      'dev4_h_w',
      'devflex1_h_w',
      'sit1a_h_w',
      'sit2a_h_w',
      'sit3_h_w',
      'sitbc_h_w',
      'pssit_h_w',
      'preview1_h_w',
      'preview2_h_w',
      'pt1_h_w',
      'pt2_h_w',
      'review1_h_w',
      'review2_h_w',
    ];

    if (env === 'local') return 'http://localhost:4005';
    if (prods.includes(env) || env.includes('prod')) return 'https://www2.bac-assets.com';
    if (environments.includes(env)) return `https://uat-${env.replace('_h_w', '')}-helix.bac-assets.com`;
    return 'https://www2.bac-assets.com';
  },








  nucleusDevelopment(env) {
    const prods = ['prod1_h_w', 'prod2_h_2'];
    const environments = [
      'dev1_h_w',
      'dev2_h_w',
      'dev3_h_w',
      'dev4_h_w',
      'devflex1_h_w',
      'sit1a_h_w',
      'sit2a_h_w',
      'sit3_h_w',
      'sitbc_h_w',
      'pssit_h_w',
      'preview1_h_w',
      'preview2_h_w',
      'pt1_h_w',
      'pt2_h_w',
      'review1_h_w',
      'review2_h_w',
    ];

    const nucleusScript = '/nucleus/spa-assets/components/utilities/global/nucleus/1.0.0/js/nucleus.js';
    const nucleusDevelopment = '/nucleus/spa-assets/components/utilities/global/nucleus-development/2.0.0/js/nucleus-development.js';

    if (env === 'local') return `http://localhost:4005${nucleusDevelopment}`;
    if (prods.includes(env) || env.includes('prod')) return `https://www2.bac-assets.com${nucleusScript}`;
    if (environments.includes(env)) return `https://uat-${env.replace('_h_w', '')}-helix.bac-assets.com${nucleusDevelopment}`;
    return `https://www2.bac-assets.com${nucleusScript}`;
  },








  requiredAttrsCheck(attrs, requiredAttrs) {
    let attr;
    for (let i = 0, len = requiredAttrs.length; i < len; i++) {
      attr = requiredAttrs[i];
      if (attrs[attr] === undefined) {
        return {
          pass: false,
          missingField: attr,
        };
      }
    }
    return {
      pass: true,
    };
  },








  orderCSS(css, assetPath) {

    const links = [];



    const loadOrder = [
      'utilities/vendor/',
      'utilities/global/sparta-style-utility',
      'utilities/global/',
      'utilities/',
      'modules/global/',
      'modules/',
    ];

    css

      .sort((a, b) => {

        let aIndex = 0;
        let bIndex = 0;


        loadOrder.some((item, index) => {

          if (a.indexOf(item) > -1) {
            aIndex = index;


            return true;
          }


          return false;
        });


        loadOrder.some((item, index) => {

          if (b.indexOf(item) > -1) {
            bIndex = index;


            return true;
          }


          return false;
        });


        return aIndex - bIndex;
      })


      .forEach((link) => {

        const href = Handlebars.helpers.pathClean(assetPath, link);


        links.push(`<link rel="stylesheet" type="text/css" href="${href}">`);
      });


    return new Handlebars.SafeString(links.join('\n\t'));
  },








  pathClean(str1, str2) {
    return (str2.charAt(0) === '/' && str1 === '/') ? str2 : `${str1.replace(/\/+$/, '')}/${str2}`;
  },








  combineAttrs(attrs, combinableAttrs) {
    let attrVal;

    Object.keys(combinableAttrs).forEach((attrName) => {
      attrVal = combinableAttrs[attrName];
      if (attrs[attrName] && attrName === 'value') {
        attrs[attrName] += attrVal;
      } else if (attrs[attrName] && attrName) {
        attrs[attrName] += ` ${attrVal}`;
      } else {
        attrs[attrName] = attrVal;
      }
    });
  },








  removeReservedAttrs(attrs, reservedAttrs) {
    for (let i = 0, len = reservedAttrs.length; i < len; i++) {
      delete attrs[reservedAttrs[i]];
    }
  },







  buildAttrsString(attrs) {
    let str = '';
    let attrVal;

    Object.keys(attrs).forEach((attrName) => {
      attrVal = attrs[attrName];
      str += ` ${attrName}=${((typeof attrVal === 'object') ? `'${JSON.stringify(attrVal)}'` : `"${attrVal}"`)}`;
    });
    return str;
  },








  extend(...args) {
    let opts;
    let target;
    let source;

    if (args.length < 3) {
      target = args[0] || {};
      source = args[1] || {};
      opts = {
        extendArray: false,
      };
    } else {
      opts = args[0] || {};
      target = args[1] || {};
      source = args[2] || {};
    }

    Object.keys(source).forEach((prop) => {

      if (typeof source[prop] === 'object') {

        if (!opts.extendArray && Array.isArray(source[prop])) {

          target[prop] = source[prop];

        } else {

          target[prop] = Handlebars.helpers.extend(target[prop], source[prop]);
        }

      } else {

        target[prop] = source[prop];
      }
    });


    return target;
  },
};




class helpersUtils {





  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = helpersUtils;
module.exports.helpers = helpers;
